import { render, staticRenderFns } from "./QuestionPage.vue?vue&type=template&id=a746f378&"
import script from "./QuestionPage.vue?vue&type=script&lang=js&"
export * from "./QuestionPage.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports